/**
 * VEHICLE-HISTORY (NUB-358)
 *
 * Both values render the same view, so this decides navigation shape only — it exists
 * so the two can be compared with technicians rather than argued about.
 *
 * `grep -rn VEHICLE-HISTORY` finds every line of this feature.
 */
export enum VehicleHistoryMount {
  TAB = "TAB",
  PAGE = "PAGE",
}

export const VEHICLE_HISTORY_MOUNT: VehicleHistoryMount = VehicleHistoryMount.TAB;

export const vehicleHistoryPath = (vehicleId: string) => `/vehicle-history/${vehicleId}`;

// Hidden for now: each Refresh is a paid Carfax lookup. Set to true to show the button again.
export const CARFAX_REFRESH_ENABLED = false;
